const styles = (theme) => ({
  header: {
    height: 'auto !important',
    maxHeight: 180,
    minHeight: 84,

    [theme.breakpoints.down('xs')]: {
      fontSize: 20,
      height: 70,
    },
  },

  container: {
    padding: theme.spacing(0, 2.5, 2.5),
  },

  text: {
    fontSize: 18,
    padding: theme.spacing(2, 0),
  },
});

export default styles;
